import type { SVGProps } from 'react';

const SvgArrowRightLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M14 18L20 12L14 6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 12L20 12' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgArrowRightLt;
